import React from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import { useSpring, animated } from 'react-spring'
import classNames from 'classnames'

import { HomeQuery } from '../../types/graphql'

import { Layout } from '../../components/Layout'
import { SEO } from '../../components/SEO'
import { SocialLinks } from '../../components/SocialLinks'

import freccia from '../../images/freccia.svg'
import img1 from '../../images/forma-griglia.svg'
import img2 from '../../images/forma-cerchio.svg'
import img3 from '../../images/forma-griglia-stondata.svg'
import img4 from '../../images/forma-pentagono.svg'
import img5 from '../../images/forma-decagono.svg'
import img6 from '../../images/forma-asterisco.svg'
import img7 from '../../images/forma-4cerchi.svg'
import img8 from '../../images/forma-biscia.svg'
import img9 from '../../images/forma-triangolo.svg'
import img10 from '../../images/forma-16cerchi.svg'
import img11 from '../../images/forma-hamburger.svg'
import img12 from '../../images/forma-cerchio.svg'

import * as classes from './home.module.scss'

const calc = (x: number, y: number) => [
  x - window.innerWidth / 2,
  y - window.innerHeight / 2,
]
const trans1 = (x: number, y: number) =>
  `translate3d(${x / 10}px,${-100 + y / 10}px,0) rotate(${x / 10}deg)`
const trans2 = (x: number, y: number) =>
  `translate3d(${x / 5 + y / 5}px,${-150 + y / 7}px,0)`
const trans3 = (x: number, y: number) =>
  `translate3d(${-50 + x / 10}px,${-250 + y / 10}px,0) rotate(${
    x / 30 + y / 10
  }deg)`
const trans4 = (x: number, y: number) =>
  `translate3d(${x / 10}px,${-350 + y / 10}px,0) rotate(${
    (x / 30) * -1 + (y / 5) * -1
  }deg)`
const trans5 = (x: number, y: number) =>
  `translate3d(${150 + x / 10}px,${-250 + y / 10}px,0) rotate(${
    x / 40 + y / 5
  }deg)`

const HomePage = () => {
  const [props, set] = useSpring(() => ({
    xy: [0, 0],
    config: { mass: 30, tension: 550, friction: 540 },
  }))
  const { allStrapiService } = useStaticQuery<HomeQuery>(graphql`
    query Home {
      allStrapiService {
        nodes {
          id
          slug
          title
        }
        totalCount
      }
    }
  `)

  return (
    <Layout>
      <SEO title='Home' />
      <div className={classNames(['container', classes.home])}>
        <SocialLinks />
        <div className={classes.shapes}>
          <div className={classes.shape1}>
            <img src={img1} alt='' />
          </div>
          <div className={classes.shape2}>
            <img src={img2} alt='' />
          </div>
          <div className={classes.shape3}>
            <img src={img3} alt='' />
          </div>
          <div className={classes.shape4}>
            <img src={img4} alt='' />
          </div>
          <div className={classes.shape5}>
            <img src={img5} alt='' />
          </div>
          <div className={classes.shape6}>
            <img src={img6} alt='' />
          </div>
          <div className={classes.shape7}>
            <img src={img7} alt='' />
          </div>
          <div className={classes.shape8}>
            <img src={img8} alt='' />
          </div>
          <div className={classes.shape9}>
            <img src={img9} alt='' />
          </div>
          <div className={classes.shape10}>
            <img src={img10} alt='' />
          </div>
          <div className={classes.shape11}>
            <img src={img11} alt='' />
          </div>
          <div className={classes.shape12}>
            <img src={img12} alt='' />
          </div>
        </div>
        <div className={classes.arrows}>
          <Link to={'/#services'}>
            <img src={freccia} alt='Servizi' />
          </Link>
        </div>
        <div className={classes.main}>
          <div className={classes.intro}>
            <h1>Trasforma gli obiettivi aziendali in risultati concreti.</h1>
            <h2>
              Raggiungi i tuoi traguardi con la nostra consulenza in digital
              marketing.
            </h2>
            <h3>
              Definiamo la strategia più efficace e produciamo contenuti per
              migliorare la presenza online e social del tuo brand.
            </h3>
          </div>
        </div>
        <div id='services' className={classes.services}>
          <div>
            {allStrapiService.nodes.map((node, index) => (
              <div className={classes.service} key={node.id}>
                <Link to={`/servizi/${node.slug}`}>{node.title}</Link>
                <span>
                  <strong>{`00${index + 1}`.slice(-2)}</strong>-
                  {`00${allStrapiService.totalCount}`.slice(-2)}
                </span>
              </div>
            ))}
          </div>

          <div className={classes.shapes}>
            <div
              onMouseMove={({ clientX: x, clientY: y }) =>
                set({ xy: calc(x, y) })
              }
            >
              <animated.div
                className={classes.card1}
                style={{ transform: props.xy.interpolate(trans1) }}
              />
            </div>

            <div
              onMouseMove={({ clientX: x, clientY: y }) =>
                set({ xy: calc(x, y) })
              }
            >
              <animated.div
                className={classes.card2}
                style={{ transform: props.xy.interpolate(trans2) }}
              />
            </div>

            <div
              onMouseMove={({ clientX: x, clientY: y }) =>
                set({ xy: calc(x, y) })
              }
            >
              <animated.div
                className={classes.card3}
                style={{ transform: props.xy.interpolate(trans3) }}
              />
            </div>

            <div
              onMouseMove={({ clientX: x, clientY: y }) =>
                set({ xy: calc(x, y) })
              }
            >
              <animated.div
                className={classes.card4}
                style={{ transform: props.xy.interpolate(trans4) }}
              />
            </div>

            <div
              onMouseMove={({ clientX: x, clientY: y }) =>
                set({ xy: calc(x, y) })
              }
            >
              <animated.div
                className={classes.card5}
                style={{ transform: props.xy.interpolate(trans5) }}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default HomePage
